import React from 'react';
import { SectionHead, Icon, Action } from './Primitives';
import './UnityImpact.css';
export default function UnityImpact({ onDemo }) {
  return (
    <section className="ul-section ul-impact" id="report">
      <div className="ul-container ul-impact-grid">
        <div className="ul-report-visual">
          <div className="ul-report-top">
            <div>
              <span>LEARNING PORTFOLIO</span>
              <h3>See the whole picture.</h3>
            </div>
            <Icon name="chart" size={25} />
          </div>
          <div className="ul-report-stats">
            <div>
              <b>48</b>
              <span>Learners</span>
            </div>
            <div>
              <b>4</b>
              <span>Programmes</span>
            </div>
            <div>
              <b className="ul-pink-text">6</b>
              <span>Need follow-up</span>
            </div>
          </div>
          <div className="ul-report-progress">
            <div>
              <h4>Programme progress</h4>
              <span>Completed assessments</span>
            </div>
            {[
              ['Staff induction', 76],
              ['Technical foundations', 62],
              ['Supplier essentials', 88],
            ].map(([name, n]) => (
              <div className="ul-report-row" key={name}>
                <span>{name}</span>
                <div className="ul-report-track">
                  <i style={{ width: `${n}%` }} />
                </div>
                <b>{n}%</b>
              </div>
            ))}
          </div>
          <div className="ul-report-insight">
            <span>
              <Icon name="chart" size={17} /> Follow-up focus
            </span>
            <p>
              Check in with learners showing extended inactivity. Review assessment evidence before
              deciding the next action.
            </p>
          </div>
          <p className="ul-report-disclosure">
            Illustrative report view · sample data, not customer results
          </p>
        </div>
        <div>
          <SectionHead
            eyebrow="04 / Give oversight real substance"
            title={
              <>
                Know where
                <br />
                your attention matters.
              </>
            }
          >
            Move from scattered updates to a clear view of learning activity, assessment evidence
            and practical follow-up needs.
          </SectionHead>
          <div className="ul-report-benefits">
            <p>
              <Icon name="check" />
              <span>
                <strong>For facilitators</strong>See progress and investigate where learners need
                support.
              </span>
            </p>
            <p>
              <Icon name="check" />
              <span>
                <strong>For funders and supervisors</strong>View the learners and programmes you’re
                responsible for.
              </span>
            </p>
            <p>
              <Icon name="check" />
              <span>
                <strong>For management</strong>Bring meaningful learning evidence into the
                conversation.
              </span>
            </p>
          </div>
          <p className="ul-note">
            Operational reports are included in Deliver. Funder and supervisor portfolio reporting
            is included in Impact.
          </p>
          <div className="ul-actions">
            <Action onClick={onDemo} secondary>
              See Unity for your team
            </Action>
          </div>
        </div>
      </div>
    </section>
  );
}
